import { Injectable } from '@angular/core';

import { AnalyticsBase } from '@core/analytics-legacy';

@Injectable({ providedIn: 'root' })
export class AdminDropdownAnalyticsService extends AnalyticsBase {
  public readonly namespace = 'MainNavigation';
  public readonly requireViewContext = false;

  public trackCompanySwitcherSelected(): void {
    this.track('AdminDropdownOptionSelected', { item: 'company_switcher' });
  }

  public trackProfileSettingsSelected(): void {
    this.track('AdminDropdownOptionSelected', { item: 'profile_settings' });
  }

  public trackLogoutSelected(): void {
    this.track('AdminDropdownOptionSelected', { item: 'logout' });
  }
}
